<div class="text-dimmed" *ngIf="payRates; else notDefined">
    <div *ngFor="let payRate of payRates.payRates" class="mt-2">
        {{ payRate.hourlyRate | amount }} {{payRate.groupClassCategory.categoryName}} <span>|</span>
        {{payRate.groupClassCategory.jobCostCode}}<span>|</span> {{payRate.groupClassCategory.clubCode}}
    </div>
</div>
<ng-template #notDefined>
    <div class="text-dimmed" translate>
        ProviderPayRates.NotDefined
    </div>
</ng-template>